import BaseShareTask from "../baseShareTask";

export default class BaseReviseShare extends BaseShareTask {
  getDeleteData = () => {
    // @ts-ignore
    return this.deleteData;
  };

  updateReviseData = (data: any) => {
    this.setState({
      reviseData: data,
    });
  };

  ReasonOnchange = (e: any) => {
    this.setState({
      reasonValue: e.value,
      reasonInputStatus: "",
    });
  };
}
